import { useContext } from 'react';

import { AuthContext, type AuthContextValue } from './AuthProvider';

/**
 * Hook for any component below `<AuthProvider>` to read the current session
 * (tenantId, licenseType, scopes) and trigger login/logout.
 */
export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (ctx === null) {
    throw new Error('useAuth must be used inside an <AuthProvider>.');
  }
  return ctx;
}
